/**
 * Birthdate Trigger Component
 *
 * Trigger: "birthday"
 * No additional fields needed.
 */

import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { TriggerComponentProps } from '../automationTriggers';

export const BirthdateTrigger: FC<TriggerComponentProps> = ({
  readOnly,
}) => {
  const { t } = useTranslation();

  if (readOnly) {
    return <span>{t('automations.triggers.birthday')}</span>;
  }

  // Edit mode - no fields needed
  return null;
};
